const Services = {
  AppDetailsService: Symbol.for('AppDetailsService'),
  DynamicContentService: Symbol.for('DynamicContentService'),
  MicrositeService: Symbol.for('MicrositeService'),
  PackageService: Symbol.for('PackageService'),
  SearchService: Symbol.for('SearchService'),
  DownloadService: Symbol.for('DownloadService'),
  IdentityService: Symbol.for('IdentityService'),
  AppCardService: Symbol.for('AppCardService'),
  VerifyService: Symbol.for('VerifyService'),
};

export { Services };
